<div class="ak-root">
  <div class="ak-yetki-bilgi" [class.ak-yetki-bilgi--yonetici]="kayitDuzenleyebilir">
    {{ kayitDuzenleyebilir ? 'Süper yönetici · kayıt düzenleme açık' : 'PDKS kayıtları salt okunur · giriş/çıkış kart ile kaydedilir' }}
  </div>
  <div class="ak-sol">

  <!-- ═══ AKTİF KART YOKSA: KART EKLE ═══ -->
  @if (!aktifSatir && !yukleniyor) {
    <div class="ke-kart ak-fade">
      <button class="ak-geri ke-geri" (click)="geriDon()">&#8592;</button>
      <div class="ke-tarih">{{ seciliGunGorunum }}</div>
      <div class="ke-ic">
        <div class="ke-plus" [class.ak-duzenlenemez]="!kayitDuzenleyebilir" (click)="kartEkle()">+</div>
        <div class="ke-baslik">Aktif Kayit Yok</div>
        <div class="ke-alt">
          <button class="ke-btn" (click)="kartEkle()" [disabled]="islemYapiliyor || !kayitDuzenleyebilir">Hemen Ekleyin</button>
          <button class="ke-btn ke-btn-link" (click)="kartEkle()" [disabled]="islemYapiliyor || !kayitDuzenleyebilir">&#128161; Kart Ekle</button>
        </div>
      </div>
      @if (!seciliGunBugunMu) {
        <button class="ak-bug-btn ke-bug" (click)="buguneGit()">Bugun</button>
      }
    </div>
  }

  <!-- ═══ AKTİF KART ═══ -->
  @if (aktifSatir || yukleniyor) {
    <div class="ak-kart ak-fade" [class.ak-gece]="geceVardiyasiMi">

      <!-- Gece vardiyası banner -->
      @if (geceVardiyasiMi) {
        <div class="ak-gece-banner">&#127769; Gece Vardiyası</div>
      }

      <!-- ── BAŞLIK + Progress Ring ── -->
      <div class="ak-baslik">
        <button class="ak-geri" (click)="geriDon()">&#8592;</button>
        <div class="ak-tarih">
          <span class="ak-gun">{{ seciliGunAdi }}</span>
          <span class="ak-tam">{{ seciliGunGorunum }}</span>
        </div>
        @if (aktifSatir) {
          <span class="ak-chip" [class]="'ak-d-' + aktifSatir.durum">{{ durumYazi(aktifSatir.durum) }}</span>
        }
        @if (!seciliGunBugunMu) {
          <button class="ak-bug-btn" (click)="buguneGit()">Bugun</button>
        }
        @if (yukleniyor) { <span class="ak-spin">&#8635;</span> }
      </div>

      <!-- ── VARDİYA SEÇİMİ ── -->
      <div class="ak-vrd" [class.ak-duzenlenemez]="!kayitDuzenleyebilir" (click)="dialogAc('vardiya-sec')">
        <span class="ak-vrd-icon">&#128260;</span>
        <span class="ak-vrd-lbl">Vardiya</span>
        <span class="ak-vrd-val">{{ aktifVardiyaIsmi }}</span>
        <span class="ak-vrd-ok">&#9656;</span>
      </div>

      <!-- ── GÜN TÜRÜ ── -->
      <div class="ak-gt">
        @for (g of gunTurleri; track g.key) {
          <button class="ak-gt-b" [disabled]="!kayitDuzenleyebilir" [class.ak-gt-sec]="gunTuru === g.key" (click)="gunTuruDegistir(g.key)">
            {{ g.ikon }} {{ g.etiket }}
          </button>
        }
      </div>

      <!-- ── SAAT TABLOSU ── -->
      <div class="ak-st">
        <div class="ak-st-col" [class.ak-duzenlenemez]="!kayitDuzenleyebilir" (click)="dialogAc('giris-saat')">
          <div class="ak-st-lbl">Giris</div>
          <div class="ak-st-val" [class.ak-st-ok]="aktifSatir?.giris" [class.ak-st-bos]="!aktifSatir?.giris">
            {{ aktifSatir?.giris ? zamanStrSn(aktifSatir.giris) : 'Seciniz' }}
          </div>
        </div>
        <div class="ak-st-col ak-st-mid" [class.ak-duzenlenemez]="!kayitDuzenleyebilir" (click)="dialogAc('mola-ekle')">
          <div class="ak-st-lbl">Mola({{ aktifSatir && aktifSatir.molaDakika > 0 ? dk2Saat(aktifSatir.molaDakika) : 'Yok' }})</div>
          <div class="ak-st-val" [class.ak-st-mola]="aktifSatir?.durum === 'molada'">
            {{ aktifSatir?.durum === 'molada' ? canliMolaStr : (aktifSatir && aktifSatir.molaDakika > 0 ? dk2Saat(aktifSatir.molaDakika) : 'Yok') }}
          </div>
        </div>
        <div class="ak-st-col" [class.ak-duzenlenemez]="!kayitDuzenleyebilir" (click)="dialogAc('cikis-saat')">
          <div class="ak-st-lbl">Cikis</div>
          <div class="ak-st-val" [class.ak-st-ok]="aktifSatir?.cikis" [class.ak-st-bos]="!aktifSatir?.cikis">
            {{ aktifSatir?.cikis ? zamanStrSn(aktifSatir.cikis) : 'Seciniz' }}
          </div>
        </div>
      </div>

      <!-- ── Circular Progress + Calisma Suresi ── -->
      <div class="ak-progress-row">
        <svg class="ak-ring" viewBox="0 0 80 80">
          <circle cx="40" cy="40" r="34" fill="none" stroke="rgba(0,0,0,.06)" stroke-width="6"/>
          <circle cx="40" cy="40" r="34" fill="none"
            [attr.stroke]="tamamlanmaYuzde >= 100 ? '#fa8c16' : '#009688'"
            stroke-width="6" stroke-linecap="round"
            [attr.stroke-dasharray]="ringCevre"
            [attr.stroke-dashoffset]="ringOffset"
            transform="rotate(-90 40 40)"
            style="transition: stroke-dashoffset .5s ease;"/>
        </svg>
        <div class="ak-ring-ic">
          <div class="ak-ring-yuzde">%{{ tamamlanmaYuzde }}</div>
        </div>
        <div class="ak-ms-dikey">
          <div class="ak-ms-col ak-ms-click" (click)="dialogAc('calisma-suresi')">
            <div class="ak-ms-lbl">Calisma</div>
            <div class="ak-ms-val" [class.ak-ms-aktif]="aktifSatir?.durum === 'aktif'">{{ canliCalismaStr }}</div>
          </div>
          <div class="ak-ms-col ak-ms-click" (click)="dialogAc('mesai-carpani')">
            <div class="ak-ms-lbl">Carpan</div>
            <div class="ak-ms-val ak-ms-oran">&times;{{ aktifCarpan.carpan }} {{ aktifCarpan.etiket }}</div>
          </div>
        </div>
      </div>

      <!-- ── Fazla Mesai Uyarısı ── -->
      @if (fazlaMesaiMs > 60 * 60_000) {
        <div class="ak-uyari" [class.ak-uyari-kirmizi]="fazlaMesaiMs > 120 * 60_000">
          &#9888;&#65039; Fazla mesai: {{ fazlaMesaiStr }}
        </div>
      }

      <!-- ── Çoklu Kayıt Bilgisi ── -->
      @if (pdks.gunlukKayitlar().length > 1) {
        <div class="ak-coklu">&#128203; {{ pdks.gunlukKayitlar().length }} ayri giris/cikis kaydi</div>
      }

      <!-- ── Normal Mesai | Fazla Mesai ── -->
      <div class="ak-ms">
        <div class="ak-ms-col">
          <div class="ak-ms-lbl">Normal Mesai</div>
          <div class="ak-ms-val">{{ normalMesaiStr }}</div>
        </div>
        <div class="ak-ms-col">
          <div class="ak-ms-lbl">Fazla Mesai</div>
          <div class="ak-ms-val" [class.ak-ms-fazla]="fazlaMesaiMs > 0">{{ fazlaMesaiStr }}</div>
        </div>
      </div>

      <!-- ── AKSİYON BUTONLARI ── -->
      @if (seciliGunBugunMu) {
        <div class="ak-aks">
          @if (!aktifSatir || aktifSatir.durum === 'gelmedi') {
            <button class="ak-btn ak-b-giris" (click)="girisYap()" [disabled]="islemYapiliyor">Giris Yap</button>
          }
          @if (aktifSatir?.durum === 'aktif') {
            <button class="ak-btn ak-b-mola" (click)="molaBaslat()" [disabled]="islemYapiliyor">Mola</button>
            <button class="ak-btn ak-b-cikis" (click)="cikisYap()" [disabled]="islemYapiliyor">Cikis Yap</button>
          }
          @if (aktifSatir?.durum === 'molada') {
            <button class="ak-btn ak-b-giris" (click)="molaBitir()" [disabled]="islemYapiliyor">Molayi Bitir</button>
          }
          @if (aktifSatir?.durum === 'cikti') {
            <div class="ak-bitti">Mesai tamamlandi &middot; <b>{{ dk2Saat(aktifSatir.toplamDakika) }}</b></div>
          }
        </div>
      } @else {
        <div class="ak-aks">
          @if (aktifSatir) {
            <div class="ak-bitti">{{ durumYazi(aktifSatir.durum) }} &middot; <b>{{ dk2Saat(aktifSatir.toplamDakika) }}</b></div>
          }
        </div>
      }

      <!-- ── DURUM BAYRAKLARI ── -->
      <div class="ak-bay">
        @for (b of bayraklar; track b.key) {
          <button class="ak-bay-b" [disabled]="!kayitDuzenleyebilir" [class.ak-bay-on]="bayrakDegeri(b.key)" (click)="bayrakToggle(b.key)" [title]="b.etiket">
            <span class="ak-bay-i">{{ b.ikon }}</span>
            <span class="ak-bay-t">{{ b.kisaEtiket }}</span>
          </button>
        }
      </div>
    </div>
  }

  <!-- ═══ AYLIK ÖZET TABLO (Flutter pattern) ═══ -->
  <div class="ak-kart oz-kart ak-fade">
    <div class="oz-baslik">
      <span class="oz-ikon">&#128197;</span>
      <span class="oz-ay">{{ AY_ISIMLERI_T[takvimAy] }} {{ takvimYil }}</span>
    </div>
    <div class="oz-grid">
      <div class="oz-satir">
        <span class="oz-lbl">Calisma Suresi</span>
        <span class="oz-val">{{ aylikOzet.calismaSuresi }}</span>
      </div>
      <div class="oz-satir">
        <span class="oz-lbl">C.Gunu Mesaileri</span>
        <span class="oz-val oz-yok">{{ aylikOzet.cGunuMesai || '&#10060; Yok' }}</span>
      </div>
      <div class="oz-satir">
        <span class="oz-lbl">D.Gunu Mesaileri</span>
        <span class="oz-val oz-yok">{{ aylikOzet.dGunuMesai || '&#10060; Yok' }}</span>
      </div>
      <div class="oz-satir">
        <span class="oz-lbl">H.Tatili Mesaileri</span>
        <span class="oz-val oz-yok">{{ aylikOzet.hTatilMesai || '&#10060; Yok' }}</span>
      </div>
      <div class="oz-satir">
        <span class="oz-lbl">R.Tatil Mesaileri</span>
        <span class="oz-val oz-yok">{{ aylikOzet.rTatilMesai || '&#10060; Yok' }}</span>
      </div>
      <div class="oz-satir">
        <span class="oz-lbl">Izinli Sure</span>
        <span class="oz-val oz-yok">{{ aylikOzet.izinliSure || '&#10060; Yok' }}</span>
      </div>
      <div class="oz-satir">
        <span class="oz-lbl">Raporlu Sure</span>
        <span class="oz-val oz-yok">{{ aylikOzet.raporluSure || '&#10060; Yok' }}</span>
      </div>
      <div class="oz-satir">
        <span class="oz-lbl">Yillik Izin</span>
        <span class="oz-val oz-yok">{{ aylikOzet.yillikIzin || '&#10060; Yok' }}</span>
      </div>
    </div>
  </div>

  </div><!-- /ak-sol -->
  <div class="ak-sag">
  <!-- ═══ TAKVİM (Flutter Hareketler TakvimGun pattern) ═══ -->
  <div class="ak-kart tk-kart ak-fade">
    <div class="tk-nav">
      <button class="tk-btn" (click)="takvimOnceki()">&#9664;</button>
      <span class="tk-ay">
        @if (takvimAy === bugunAy && takvimYil === bugunYil) { <span class="tk-su">&#128073;</span> }
        {{ AY_ISIMLERI_T[takvimAy] }} {{ takvimYil }}
      </span>
      <button class="tk-btn" (click)="takvimSonraki()">&#9654;</button>
    </div>
    <div class="tk-hdr">
      @for (g of HAFTA_KISA; track $index) {
        <span class="tk-hdr-g" [class.tk-hdr-hs]="$index >= 5">{{ g }}</span>
      }
    </div>
    <div class="tk-grid">
      @for (h of takvimHucreleri; track $index) {
        <div class="tk-gun" [class.tk-dis]="!h.ayIci" (click)="takvimGunSec(h)">
          <!-- Header: gun no + gun kisa ismi -->
          <div class="tk-gun-hdr"
            [class.tk-hdr-bug]="h.bugun"
            [class.tk-hdr-hs2]="h.haftaSonu && !h.bugun && h.ayIci"
            [class.tk-hdr-sec]="h.secili && !h.bugun"
            [class.tk-hdr-normal]="!h.bugun && !h.haftaSonu && h.ayIci && !h.secili">
            <span>{{ h.gunNo }} {{ gunKisaIsim(h.tarih) }}</span>
          </div>
          <!-- Orta ikon -->
          @if (h.ayIci) {
            <div class="tk-gun-ic">
              @if (h.veri) {
                <span class="tk-ikon tk-ikon-var" [style.color]="h.veri.renk || '#52c41a'">&#128344;</span>
                @if (h.veri.fazlaMesaiVar) { <span class="tk-fm-badge">&#10133;</span> }
                @if (h.veri.gecGelme) { <span class="tk-gc-badge">&#9888;</span> }
                @if (h.veri.kayitSayisi && h.veri.kayitSayisi > 1) { <span class="tk-multi-badge">{{ h.veri.kayitSayisi }}</span> }
              } @else {
                <span class="tk-ikon tk-ikon-yok">&#128683;</span>
              }
            </div>
          }
          <!-- Alt: giris-cikis + sure -->
          @if (h.ayIci) {
            <div class="tk-gun-alt">
              @if (h.veri?.girisStr) {
                <span class="tk-gun-gc">{{ h.veri.girisStr }}{{ h.veri.cikisStr ? '-' + h.veri.cikisStr : '' }}</span>
              }
              <span class="tk-gun-sure2">{{ h.veri && h.veri.toplamDk > 0 ? dk2SaatKisa(h.veri.toplamDk) : '00:00' }}</span>
            </div>
          }
          <!-- Kose badge'leri -->
          @if (h.ayIci) {
            @if (h.veri?.notVar) { <span class="tk-badge tk-badge-tr">&#128172;</span> }
            @if (h.veri?.resmiTatil) { <span class="tk-badge tk-badge-tl">&#128681;</span> }
            @if (h.veri?.raporlu) { <span class="tk-badge tk-badge-bl">&#128150;</span> }
            @if (h.veri?.izinli) { <span class="tk-badge tk-badge-br">&#128716;</span> }
          }
        </div>
      }
    </div>
    <!-- Alt ozet: Normal Mesai / Fazla Mesai -->
    <div class="tk-ozet">
      <div class="tk-ozet-satir">
        <span class="tk-ozet-lbl">Normal Mesai</span>
        <span class="tk-ozet-val">{{ aylikOzet.calismaSuresi }}</span>
      </div>
      <div class="tk-ozet-satir">
        <span class="tk-ozet-lbl">Fazla Mesai</span>
        <span class="tk-ozet-val tk-ozet-fazla">{{ aylikOzet.fazlaMesai || 'Yok' }}</span>
      </div>
    </div>
  </div>

  <!-- ═══ AYLIK DETAY RAPOR ═══ -->
  @if (aktifPersonel) {
    <pdks-aylik-ozet [firmaId]="firmaId" [personelId]="aktifPersonel._id"></pdks-aylik-ozet>
  }

  </div><!-- /ak-sag -->

  <!-- ══════ DIALOG: GİRİŞ SAATİ ══════ -->
  @if (aktifDialog === 'giris-saat') {
    <div class="dlg-ov" (click)="dialogKapat()">
      <div class="dlg" (click)="$event.stopPropagation()">
        <div class="dlg-head"><span class="dlg-simge">&#128344;</span> Giris Saatiniz</div>
        <div class="dlg-body">
          @if (!seciliGunBugunMu) { <div class="dlg-tarih">{{ seciliGunGorunum }}</div> }
          @if (aktifSatir?.giris) {
            <div class="dlg-info">{{ zamanStrSn(aktifSatir.giris) }}</div>
          }
          <div class="dlg-row">
            <label>Saat Sec</label>
            <input type="time" step="1" [(ngModel)]="dlgGirisSaat" class="dlg-input" />
          </div>
          <div class="dlg-row-btns">
            @if (seciliGunBugunMu) {
              <button class="dlg-pill dlg-pill-blue" (click)="dlgGirisSimdi()">&#9203; Simdi</button>
            }
            <button class="dlg-pill dlg-pill-blue" (click)="dlgGirisNormal()">&#9203; Giris Saati</button>
          </div>
        </div>
        <div class="dlg-foot">
          <button class="dlg-f-btn dlg-f-red" (click)="dlgGirisSil()">Girisi Sil</button>
          <span class="dlg-spacer"></span>
          <button class="dlg-f-btn dlg-f-green" (click)="dlgGirisKaydet()">Kaydet</button>
          <button class="dlg-f-btn dlg-f-green" (click)="dialogKapat()">Kapat</button>
        </div>
      </div>
    </div>
  }

  <!-- ══════ DIALOG: ÇIKIŞ SAATİ ══════ -->
  @if (aktifDialog === 'cikis-saat') {
    <div class="dlg-ov" (click)="dialogKapat()">
      <div class="dlg" (click)="$event.stopPropagation()">
        <div class="dlg-head"><span class="dlg-simge">&#128344;</span> Cikis Saatiniz</div>
        <div class="dlg-body">
          @if (!seciliGunBugunMu) { <div class="dlg-tarih">{{ seciliGunGorunum }}</div> }
          @if (aktifSatir?.cikis) {
            <div class="dlg-info">{{ zamanStrSn(aktifSatir.cikis) }}</div>
          }
          <div class="dlg-row">
            <label>Saat Sec</label>
            <input type="time" step="1" [(ngModel)]="dlgCikisSaat" class="dlg-input" />
          </div>
          <div class="dlg-row-btns">
            @if (seciliGunBugunMu) {
              <button class="dlg-pill dlg-pill-blue" (click)="dlgCikisSimdi()">&#9203; Simdi</button>
            }
            <button class="dlg-pill dlg-pill-blue" (click)="dlgCikisNormal()">&#9203; Cikis Saati</button>
          </div>
        </div>
        <div class="dlg-foot">
          <button class="dlg-f-btn dlg-f-red" (click)="dlgCikisSil()">Cikisi Sil</button>
          <span class="dlg-spacer"></span>
          <button class="dlg-f-btn dlg-f-green" (click)="dlgCikisKaydet()">Kaydet</button>
          <button class="dlg-f-btn dlg-f-green" (click)="dialogKapat()">Kapat</button>
        </div>
      </div>
    </div>
  }

  <!-- ══════ DIALOG: MOLALAR ══════ -->
  @if (aktifDialog === 'mola-ekle') {
    <div class="dlg-ov" (click)="dialogKapat()">
      <div class="dlg" (click)="$event.stopPropagation()">
        <div class="dlg-head"><span class="dlg-simge">&#9749;</span> Molalar</div>
        <div class="dlg-body">
          @if (!seciliGunBugunMu) { <div class="dlg-tarih">{{ seciliGunGorunum }}</div> }
          <div class="dlg-row-btns">
            <button class="dlg-pill dlg-pill-blue" (click)="dlgGecerliMolalar()" [disabled]="islemYapiliyor">&#9203; Gecerli Molalar</button>
          </div>
          @if (aktifSatir) {
            <div class="dlg-mola-list">
              @for (m of molaCiftleri; track $index) {
                <div class="dlg-mola-cift">
                  <span class="dlg-mola-isim">{{ m.ismi || ('Mola ' + ($index + 1)) }}</span>
                  <div class="dlg-mola-zaman-row">
                    <span class="dlg-mola-zaman">{{ zamanStr(m.baslangic) }}</span>
                    <span class="dlg-mola-ok">&#8594;</span>
                    <span class="dlg-mola-zaman">{{ m.bitis ? zamanStr(m.bitis) : '...' }}</span>
                  </div>
                  <span class="dlg-mola-sure-txt">{{ m.sure > 0 ? dk2Saat(m.sure) : 'Devam' }}</span>
                </div>
              } @empty {
                <div class="dlg-bos">Mola kaydi yok</div>
              }
            </div>
          }
          <nz-divider style="margin:6px 0"></nz-divider>
          <div class="dlg-row">
            <label>Mola Ismi</label>
            <input type="text" [(ngModel)]="yeniMolaIsmi" placeholder="Ogle molasi..." class="dlg-input" />
          </div>
          <div class="dlg-mola-row">
            <div class="dlg-row" style="flex:1">
              <label>Baslangic</label>
              <input type="time" [(ngModel)]="yeniMolaBaslangic" class="dlg-input" />
            </div>
            <div class="dlg-row" style="flex:1">
              <label>Bitis</label>
              <input type="time" [(ngModel)]="yeniMolaBitis" class="dlg-input" />
            </div>
          </div>
          @if (yeniMolaBaslangic && yeniMolaBitis) {
            <div class="dlg-mola-sure-preview">Sure: {{ yeniMolaSure }}</div>
          }
          <div class="dlg-row-btns">
            <button class="dlg-pill dlg-pill-blue" (click)="dlgMolaEkle()" [disabled]="!yeniMolaBaslangic || islemYapiliyor">+ Mola Ekle</button>
          </div>
        </div>
        <div class="dlg-foot">
          <button class="dlg-f-btn dlg-f-red" (click)="dlgMolalarTemizle()">&#128465; Temizle</button>
          <span class="dlg-spacer"></span>
          <button class="dlg-f-btn dlg-f-green" (click)="dialogKapat()">Kapat</button>
        </div>
      </div>
    </div>
  }

  <!-- ══════ DIALOG: MESAİ ÇARPANI ══════ -->
  @if (aktifDialog === 'mesai-carpani') {
    <div class="dlg-ov" (click)="dialogKapat()">
      <div class="dlg" (click)="$event.stopPropagation()">
        <div class="dlg-head"><span class="dlg-simge">&#128200;</span> Fazla Mesai Orani</div>
        <div class="dlg-body">
          <div class="dlg-info">%{{ dlgMesaiOrani }}</div>
          <input type="range" min="0" max="400" step="10" [(ngModel)]="dlgMesaiOrani" class="dlg-slider" />
          <div class="dlg-slider-labels"><span>%0</span><span>%100</span><span>%200</span><span>%300</span><span>%400</span></div>
          <div class="dlg-row"><label>Oran (%)</label><input type="number" min="0" max="400" [(ngModel)]="dlgMesaiOrani" class="dlg-input" /></div>
          <div class="dlg-row-btns">
            <button class="dlg-pill dlg-pill-blue" (click)="dlgMesaiOrani = 50">%50</button>
            <button class="dlg-pill dlg-pill-blue" (click)="dlgMesaiOrani = 100">%100</button>
            <button class="dlg-pill dlg-pill-blue" (click)="dlgMesaiOrani = 150">%150</button>
          </div>
        </div>
        <div class="dlg-foot">
          <button class="dlg-f-btn dlg-f-red" (click)="dialogKapat()">Iptal</button>
          <span class="dlg-spacer"></span>
          <button class="dlg-f-btn dlg-f-green" (click)="dlgMesaiKaydet()">Kaydet</button>
        </div>
      </div>
    </div>
  }

  <!-- ══════ DIALOG: VARDİYA SEÇİMİ ══════ -->
  @if (aktifDialog === 'vardiya-sec') {
    <div class="dlg-ov" (click)="dialogKapat()">
      <div class="dlg" (click)="$event.stopPropagation()">
        <div class="dlg-head"><span class="dlg-simge">&#128260;</span> Vardiya Secimi</div>
        <div class="dlg-body">
          @for (v of vardiyalar; track $index) {
            <button class="dlg-vrd" [class.dlg-vrd-sec]="aktifVardiyaIdx === $index" (click)="vardiyaSec($index)">
              <span class="dlg-vrd-isim">&#127744; {{ v.ismi }}</span>
              @if (v.aciklama) { <span class="dlg-vrd-acik">{{ v.aciklama }}</span> }
              @if (v.molalar?.length) { <span class="dlg-vrd-mola">{{ v.molalar.length }} mola tanimli</span> }
            </button>
          } @empty { <div class="dlg-bos">Tanimli vardiya yok</div> }
        </div>
        <div class="dlg-foot"><span class="dlg-spacer"></span><button class="dlg-f-btn dlg-f-green" (click)="dialogKapat()">Kapat</button></div>
      </div>
    </div>
  }

  <!-- ══════ DIALOG: ÇALIŞMA SÜRESİ ══════ -->
  @if (aktifDialog === 'calisma-suresi') {
    <div class="dlg-ov" (click)="dialogKapat()">
      <div class="dlg" (click)="$event.stopPropagation()">
        <div class="dlg-head"><span class="dlg-simge">&#9201;</span> Calisma Suresi</div>
        <div class="dlg-body">
          <div class="dlg-info">{{ dk2Saat(dlgCalismaSuresiDk) }}</div>
          <input type="range" min="0" max="720" step="5" [(ngModel)]="dlgCalismaSuresiDk" class="dlg-slider" />
          <div class="dlg-slider-labels"><span>0s</span><span>3s</span><span>6s</span><span>9s</span><span>12s</span></div>
          <div class="dlg-row"><label>Sure (dakika)</label><input type="number" min="0" max="720" [(ngModel)]="dlgCalismaSuresiDk" class="dlg-input" /></div>
          <div class="dlg-row-btns">
            <button class="dlg-pill dlg-pill-blue" (click)="dlgCalismaSuresiDk = 450">&#9203; 7,5 Saat</button>
            <button class="dlg-pill dlg-pill-blue" (click)="dlgCalismaSuresiDk = 540">&#9203; 9 Saat</button>
            <button class="dlg-pill dlg-pill-blue" (click)="dlgCalismaSuresiDk = 660">&#9203; 11 Saat</button>
          </div>
        </div>
        <div class="dlg-foot">
          <button class="dlg-f-btn dlg-f-red" (click)="dialogKapat()">Iptal</button>
          <span class="dlg-spacer"></span>
          <button class="dlg-f-btn dlg-f-green" (click)="dlgCalismaSuresiKaydet()">Kaydet</button>
        </div>
      </div>
    </div>
  }

</div>
